import { render, staticRenderFns } from "./ProposalNameTooltip.vue?vue&type=template&id=49b71620&scoped=true"
import script from "./ProposalNameTooltip.vue?vue&type=script&lang=js"
export * from "./ProposalNameTooltip.vue?vue&type=script&lang=js"
import style0 from "./ProposalNameTooltip.vue?vue&type=style&index=0&id=49b71620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b71620",
  null
  
)

export default component.exports